import React from 'react';
import { FormControlLabel, Radio } from '@mui/material';
// import { RadioCheckedIcon } from '../../icons/RadioCheckedIcon';
// import { RadioIcon } from '../../icons/RadioIcon';
export const RadioButton = ({ label = '', ...props }) => {
    return (React.createElement(FormControlLabel, { ...props, label: label, control: React.createElement(Radio, null) }));
};
